import type { ICookie, ICookieExpiration, IReactCookieOptions } from '../models';

function calculateExpirationToSeconds(exp: ICookieExpiration) {
    const { days, hours } = exp;
    let seconds = 0;

    if (hours) {
        seconds += hours * 60 * 60;
    }
    if (days) {
        seconds += days * 24 * 60 * 60;
    }

    return seconds || undefined;
}

export function processOptions(opts: Omit<ICookie, 'cookieName'>): IReactCookieOptions {
    const { domain, expiresAfter, path } = opts;
    const optionResults: IReactCookieOptions = {
        domain,
    };

    if (path) {
        optionResults.path = path;
    }

    if (expiresAfter) {
        optionResults.maxAge = calculateExpirationToSeconds(expiresAfter);
    }

    return optionResults;
}
